var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPlayVideo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "25px",
    viewBox: "0 0 19 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icPlayVideo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Technical-Support-Video",
    transform: "translate(-266.000000, -377.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bitmap",
    transform: "translate(185.000000, 339.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.1956796,50.0098039 L81.933356,38.1047531 C81.7506134,37.9791549 81.5137029,37.9660593 81.3184601,38.0678475 C81.122622,38.1708262 81,38.373212 81,38.594646 L81,62.4047475 C81,62.6261814 81.122622,62.8291625 81.3184601,62.9321412 C81.405367,62.9773804 81.5006074,63 81.5952525,63 C81.7137078,63 81.8315678,62.9642848 81.933356,62.8946403 L99.1956796,50.9895896 C99.356993,50.8782773 99.4528286,50.6955348 99.4528286,50.4996967 C99.4528286,50.3038586 99.3563977,50.1211161 99.1956796,50.0098039 Z",
    id: "icPlayVideo"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPlayVideo);
export default __webpack_public_path__ + "static/media/icPlayVideo.6ca25d13623b59ca73378b1dcf326f04.svg";
export { ForwardRef as ReactComponent };